module.exports = __webpack_public_path__ + "img/footerLogo.7e115c1f.png";